export const getQueryParamValue = (
  param: string,
  uri: string = window.location.href,
): string | null => {
  const search = uri.split('?')[1]
  if (search) {
    const searchArr = search.split('&')
    const found = searchArr.find(keyVal => {
      const keyValArr = keyVal.split('=')
      return keyValArr[0] === param
    })
    if (found && found.length) {
      return found.split('=')[1]
    }
  }
  return null
}
